import React from 'react';

import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar'

import Indicator from '../containers/Indicator'

function reverseSort([id1,indicator1], [id2,indicator2] ) {    
    if (indicator1.sort < indicator2.sort) return 1
    if (indicator1.sort > indicator2.sort) return -1
    return 0
}

export default class Dimension extends React.Component  {

    componentDidMount() {
        const {fetchAnswersIfNeeded, parentId,cpId, dimensionId} = this.props
        fetchAnswersIfNeeded(parentId,cpId, dimensionId)
    }


    render() {
      const {cpId, dimensionId,answerId, item, handleTextOnChange, parentId, errorMessage } = this.props
      return <div  className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg12">
            <hr />
            {errorMessage && errorMessage.id === dimensionId 
                ? <MessageBar
                messageBarType={ MessageBarType.error }
                isMultiline={ false }>
                There was a problem saving your answer
                </MessageBar>
                : ''}        
        </div>
        <div  className="ms-Grid-col ms-lg2" ><strong>{item.name} </strong> {item.description} </div>
        {item.indicators ? Object.entries(item.indicators)
            .sort(reverseSort)
            .map( ( [indicatorId,indicator] ,i) => 
            <Indicator key={i} parentId={parentId} cpId={cpId} dimensionId={dimensionId} 
                indicatorId={indicatorId} checked={answerId === indicatorId}
                text={indicator.text} />    
            )
            :  <span>Loading</span>}
       </div>
    }
}




// WEBPACK FOOTER //
// ./src/activities/components/Dimension.js